// extracted by mini-css-extract-plugin
export default {"parent":"Iconsection_parent__IiBak"};